import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createElementVNode("link", {
      rel: "stylesheet",
      type: "text/css",
      href: "//fonts.googleapis.com/css?family=Pacifico"
    }, null, -1)),
    _createVNode(_component_ion_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_split_pane, {
          "content-id": "main-content",
          class: "main-split-pane"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_menu, {
              "content-id": "main-content",
              type: "overlay"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_header, { class: "top-logo" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_thumbnail, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_img, { src: "/assets/icon/icon.png" })
                          ]),
                          _: 1
                        }),
                        _cache[0] || (_cache[0] = _createElementVNode("h1", {
                          class: "ion-padding ion-margin-vertical",
                          style: {"color":"goldenrod","font-size":"40px","font-family":"Pacifico"}
                        }, [
                          _createElementVNode("b", null, "Gruntled")
                        ], -1))
                      ]),
                      _: 1,
                      __: [0]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_content, null, {
                  default: _withCtx(() => [
                    (!_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 0,
                          value: "first"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createElementVNode("h1", null, "Welcome!", -1)
                              ])),
                              _: 1,
                              __: [1]
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_ion_list, {
                          key: 1,
                          class: "sidebar"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_menu_toggle, { "auto-hide": false }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": "/login",
                                  lines: "none",
                                  class: _normalizeClass(["hydrated", _ctx.isSelected('/login')])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode("Login", -1)
                                      ])),
                                      _: 1,
                                      __: [2]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": "/create-account",
                                  lines: "none",
                                  class: _normalizeClass(["hydrated", _ctx.isSelected('/create-account')])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("Create Account", -1)
                                      ])),
                                      _: 1,
                                      __: [3]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_accordion, { value: "FirstName" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  slot: "header",
                                  color: "light"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h1", null, _toDisplayString(_ctx.User?.Employer?.Name), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _withDirectives(_createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": "/contributions",
                                  lines: "none",
                                  class: _normalizeClass(["hydrated", _ctx.isSelected('/contributions')]),
                                  slot: "content"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode("Employee Contributions", -1)
                                      ])),
                                      _: 1,
                                      __: [4]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]), [
                                  [_vShow, _ctx.User?.Permissions?.includes('executive')]
                                ]),
                                _withDirectives(_createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": "/disbursements",
                                  lines: "none",
                                  class: _normalizeClass(["hydrated", _ctx.isSelected('/disbursements')]),
                                  slot: "content"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode("Disbursements", -1)
                                      ])),
                                      _: 1,
                                      __: [5]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]), [
                                  [_vShow, _ctx.User?.Permissions?.includes('executive')]
                                ]),
                                _withDirectives(_createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": "/company-settings",
                                  lines: "none",
                                  class: _normalizeClass(["hydrated", _ctx.isSelected('/company-settings')]),
                                  slot: "content"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                                        _createTextVNode("Company Settings", -1)
                                      ])),
                                      _: 1,
                                      __: [6]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]), [
                                  [_vShow, _ctx.User?.Permissions?.includes('executive')]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_ion_list, {
                          key: 3,
                          class: "sidebar"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.User.Routes.manager, (p, i) => {
                              return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                                "auto-hide": false,
                                key: i
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    "router-direction": "root",
                                    "router-link": p.url,
                                    lines: "none",
                                    class: _normalizeClass(["hydrated", _ctx.isSelected(p.url)])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        ios: _ctx.getIcon('ios', p.iosIcon),
                                        md: _ctx.getIcon('md', p.mdIcon)
                                      }, null, 8, ["ios", "md"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(p.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["router-link", "class"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 4 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_accordion, { value: "FirstName" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  slot: "header",
                                  color: "light"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h1", null, _toDisplayString(_ctx.User?.FirstName) + " " + _toDisplayString(_ctx.User?.LastName), 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.User?.Email), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": "/my-nominations",
                                  lines: "none",
                                  class: _normalizeClass(["hydrated", _ctx.isSelected('/my-nominations')]),
                                  slot: "content"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                                        _createTextVNode("My Contributions", -1)
                                      ])),
                                      _: 1,
                                      __: [7]
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_ion_list, {
                          key: 5,
                          class: "sidebar"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.User.Routes.user, (p, i) => {
                              return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                                "auto-hide": false,
                                key: i
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    "router-direction": "root",
                                    "router-link": p.url,
                                    lines: "none",
                                    class: _normalizeClass(["hydrated", _ctx.isSelected(p.url)])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        ios: _ctx.getIcon('ios', p.iosIcon),
                                        md: _ctx.getIcon('md', p.mdIcon)
                                      }, null, 8, ["ios", "md"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(p.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["router-link", "class"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_router_outlet, { id: "main-content" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}